import { Navigate } from "react-router-dom"
import { Autenticacao } from "../Token"
import propsComponentePrivado from "../../interfaces/propsComponentePrivado"

const ComponentePrivado = ( props: propsComponentePrivado) => {

    const usuario = Autenticacao ()
    const urlPathName = window.location.pathname.substring(1);

    if (!usuario) {
        return <Navigate to={`/portal-auth?redirect=${urlPathName}`}></Navigate>
    }
    
    return props.children

}

export default ComponentePrivado